import { createContext } from "react";

export const AccionesRolesContext = createContext()
export const AccionesRolesFormContext = createContext()
export const AccionesRolesReportContext = createContext()